export default "__VITE_ASSET__jZ_gMyGv__";